<template>
  <div>
    <b-modal
      v-model="invoiceGenerationModal.show"
      title="Generar factura"
      size="lg"
      id="bv-modal-example"
      @hidden="resetModal"
      hide-footer
    >
      <div class="d-block">
        <span v-if="invoiceGenerationModal.hasTotalInvoice"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene una factura
          total generada. No es posible generar más facturas.</span
        >
        <span v-else-if="invoiceGenerationModal.invoices.length > 1"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene
          {{ invoiceGenerationModal.invoices.length }} facturas parciales
          generadas. Si lo deseas, puedes generar otra factura parcial.<br />Antes
          de hacerlo, recuerda comprobar que la suma de esta y las anteriores no
          supere el precio total del pedido.</span
        >
        <span v-else-if="invoiceGenerationModal.invoices.length === 1"
          >El pedido #{{ invoiceGenerationModal.orderId }} ya tiene 1 factura
          parcial generada. Si lo deseas, puedes generar otra factura
          parcial.<br />Antes de hacerlo, recuerda comprobar que la suma de esta
          y las anteriores no supere el precio total del pedido.</span
        >
        <span v-else
          >El pedido #{{ invoiceGenerationModal.orderId }} aún no tiene ninguna
          factura generada. <br />¿Qué quieres hacer?</span
        >
      </div>

      <b-row
        class="mt-2 align-items-center"
        v-if="!invoiceGenerationModal.hasTotalInvoice"
      >
        <b-col v-if="!(invoiceGenerationModal.invoices.length > 0)">
          <b-button
            variant="outline-primary"
            block
            @click="previewTotalInvoice()"
            >Previsualizar factura total</b-button
          >
          <!-- <b-button
            variant="outline-secondary"
            block
            @click="generateTotalInvoice()"
            >Generar factura total</b-button
          > -->
        </b-col>
        <b-col v-if="!(invoiceGenerationModal.invoices.length > 0)" cols="auto"
          >o bien</b-col
        >
        <b-col>
          <b-input-group>
            <b-form-input
              type="text"
              id="amount"
              :value="$v.form.amount.$model.replace('.', ',')"
              @change="setDecimal('amount', $event)"
              :state="validateState('amount')"
              aria-describedby="input-amount-feedback"
              placeholder="123,45"
            ></b-form-input>
            <template #prepend>
              <b-input-group-text>Cantidad (con IVA):</b-input-group-text>
            </template>
            <template #append>
              <b-input-group-text>€</b-input-group-text>
            </template>
          </b-input-group>
          <b-form-invalid-feedback
            :state="validateState('amount')"
            id="input-amount-feedback"
            >Este campo debe ser un número positivo.</b-form-invalid-feedback
          >

          <b-button
            class="mt-2"
            variant="outline-primary"
            @click="previewPartialInvoice()"
            block
            >Previsualizar factura parcial</b-button
          >

          <!-- <b-button
            class="mt-2"
            variant="outline-secondary"
            @click="generatePartialInvoice()"
            block
            >Generar factura parcial</b-button
          > -->
        </b-col>
      </b-row>
      <b-row class="mt-4" v-if="pdfUrl">
        <b-col :cols="12">
          <iframe class="pdfPreview" :src="pdfUrlFinal"></iframe>
        </b-col>
        <b-col :cols="12">
          <b-row class="mt-2">
            <b-col>
              <b-button
                block
                variant="secondary"
                :href="customersLink"
                target="_blank"
                >Ir a ficha cliente</b-button
              ></b-col
            >
            <b-col
              ><b-button
                block
                variant="secondary"
                :href="quotesLink"
                target="_blank"
                >Ir a presupuesto</b-button
              ></b-col
            >
            <b-col
              ><b-button
                block
                variant="primary"
                @click="confirmGenerateInvoice()"
                >Confirmar factura
                {{
                  lastTypePreviewed == 'partial' ? 'parcial' : 'total'
                }}</b-button
              ></b-col
            >
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <OpenOrdersModal
      :readOnly="true"
      :id="null"
      :valDeadlineWorkshopOverride="null"
    />
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Pedidos</h2>
          <p>
            En este apartado se pueden gestionar los pedidos del taller
            correspondientes a presupuestos. <br />Para ver los pedidos de
            taller correspondientes a stock, ir a
            <b-link :to="{ name: 'AdminWorkshopStockOrdersScreen' }"
              >Pedidos stock</b-link
            >.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de pedidos</h3>
              <v-server-table
                name="workshop_orders"
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminWorkshopOrdersEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nuevo pedido</b-button
                  > -->
                  <!-- <b-button
                    class="ml-3"
                    variant="primary"
                    v-b-modal.workshop-date-modal
                    ><b-icon icon="calendar-3" /> Calendario de
                    pedidos</b-button
                  > -->

                  <!-- <b-button
                    @click="refreshTable()"
                    class="ml-3"
                    variant="outline-primary"
                    ><b-icon icon="arrow-clockwise" /> Refrescar</b-button
                  > -->
                  <!-- <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  > -->
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <template v-slot:modified_at="props">
                  <span>{{ props.row.modified_at }}</span>
                </template>

                <template v-slot:created_by="props">
                  <span>{{
                    props.row.created_by.map((x) => x.first_name).join(', ')
                  }}</span>
                </template>

                <template v-slot:origin="props">
                  <span>
                    <div v-if="props.row.quote_id">
                      <b-link
                        :to="{
                          name: 'AdminQuotesEditScreen',
                          params: { id: props.row.quote_id },
                        }"
                        >ppto. {{ props.row.quote_id }}</b-link
                      >
                    </div>
                    <div v-else>Venta web</div>
                  </span>
                </template>

                <template v-slot:destination="props">
                  <!-- Recogida en tienda -->
                  <span
                    v-if="
                      props.row.quote &&
                      props.row.quote.shipping_method_full &&
                      [1, 2].includes(props.row.quote.shipping_method_full.id)
                    "
                    >{{ props.row.quote.shipping_method_full.name }}
                  </span>
                  <!-- Envío -->
                  <span
                    v-else-if="
                      props.row.quote &&
                      props.row.quote.shipping_method_full &&
                      ![1, 2].includes(props.row.quote.shipping_method_full.id)
                    "
                    >{{ props.row.quote.shipping_method_full.name }} ({{
                      props.row.quote.shipping_address_full
                        ? props.row.quote.shipping_address_full.city
                        : ''
                    }},
                    {{
                      props.row.quote.shipping_address_full
                        ? props.row.quote.shipping_address_full.country
                        : '-'
                    }})
                  </span>
                  <span v-else>-</span>
                </template>

                <template v-slot:in_delivery="props">
                  <span>{{
                    props.row.delivery
                      ? 'Albarán #' +
                        props.row.delivery.id +
                        ' (' +
                        props.row.delivery.location_full.name_short +
                        ')'
                      : '-'
                  }}</span>
                </template>

                <template v-slot:abbr_product_names="props">
                  <div
                    :key="i"
                    v-for="(abbr_product_name, i) in props.row
                      .abbr_product_names"
                  >
                    {{
                      abbr_product_name['qty'] +
                      ' x ' +
                      abbr_product_name['name']
                    }}
                  </div>
                </template>

                <template v-slot:created_at="props">
                  <span>{{ props.row.created_at }}</span>
                </template>

                <template v-slot:total_price="props">
                  <span>{{ props.row.total_price }} €</span>
                </template>

                <template v-slot:status="props">
                  <span>{{ props.row.status | formatStatus }}</span>
                </template>

                <template v-slot:quote_id="props">
                  <div
                    v-if="
                      props.row.workshoporderstatushistory_set.length === 1 &&
                      props.row.workshoporderstatushistory_set[0].status ===
                        'Delivered'
                    "
                  >
                    Venta en tienda (<b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >)
                  </div>
                  <div v-else-if="props.row.quote_id">
                    <b-link
                      :to="{
                        name: 'AdminQuotesEditScreen',
                        params: { id: props.row.quote_id },
                      }"
                      >ppto. {{ props.row.quote_id }}</b-link
                    >
                  </div>
                  <div v-else>Venta web</div>
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminWorkshopOrdersEditScreen',
                      params: { id: props.row.id.toString() },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="pencil" aria-hidden="true" />
                  </b-button>

                  <!-- <b-button
                    @click="downloadOrder(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon
                      icon="file-earmark-arrow-down"
                      aria-hidden="true"
                    ></b-icon>
                    Pedido
                  </b-button> -->

                  <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <b-button
                      @click="
                        downloadOrderLegalBtn(
                          props.row.id,
                          props.row.invoice,
                          props.row.customer_id,
                          props.row.quote_id
                        )
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                    >
                      <!-- {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }} -->
                      Generar factura
                    </b-button>
                  </span>

                  <b-tooltip
                    placement="left"
                    v-if="
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                    "
                    :target="'btn-' + props.row.id"
                    triggers="hover"
                  >
                    {{
                      !props.row.billing_address_id ||
                      props.row.billing_address_company.company_id === null ||
                      props.row.billing_address_company.company_id === ''
                        ? 'Debe constar una dirección de facturación y esta debe contener un identificador de empresa/autónomo (CIF)'
                        : ''
                    }}
                  </b-tooltip>
                  <b-button
                    @click="downloadOrderWorkshop(props.row.id)"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    ><b-icon icon="gear-fill" aria-hidden="true"></b-icon> Orden
                  </b-button>

                  <!-- <span
                    :id="'btn-' + props.row.id"
                    class="d-inline-block"
                    tabindex="0"
                  >
                    <b-button
                      @click="
                        downloadWorkshopOrderLegal(
                          props.row.id,
                          props.row.invoice
                        )
                      "
                      :id="'btn-' + props.row.id"
                      size="sm"
                      variant="outline-primary"
                      class="mr-2"
                      :disabled="
                        !props.row.billing_address_id ||
                        props.row.billing_address_company.company_id === null ||
                        props.row.billing_address_company.company_id === ''
                      "
                      ><b-icon
                        icon="file-earmark-check"
                        aria-hidden="true"
                      ></b-icon>
                      {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }}
                      Factura
                    </b-button>
                  </span> -->

                  <b-button
                    @click="removeOrder(props.row.id)"
                    :disabled="
                      props.row.status !== 'Received' ||
                      props.row.invoice.length > 0 ||
                      !!props.row.delivery
                    "
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    ><b-icon icon="trash" aria-hidden="true" />
                  </b-button>
                </template>

                <template v-slot:invoice="props">
                  <div v-if="props.row.invoice">
                    <b-row :key="inv.id" v-for="inv in props.row.invoice">
                      <b-col cols="12">
                        <b-button
                          block
                          @click="downloadInvoice(inv.id)"
                          :id="'btn-' + props.row.id"
                          size="sm"
                          class="mb-1"
                          variant="outline-primary"
                          ><b-icon
                            icon="file-earmark-arrow-down"
                            aria-hidden="true"
                          ></b-icon>
                          <!-- {{
                      props.row.invoice
                        ? 'Factura (' + props.row.invoice + ')'
                        : 'Factura'
                    }} -->
                          {{ inv.id }} ({{
                            inv.is_partial
                              ? `Parcial ${inv.amount} €`
                              : 'Total'
                          }})
                        </b-button>
                      </b-col></b-row
                    >
                  </div>
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { required, decimal, minValue } from 'vuelidate/lib/validators';
import { uris, actions } from '@/admin/api.js';
import OpenOrdersModal from '@/admin/components/orders/OpenOrdersModal.vue';

import store from '@/admin/store.js';

import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'AdminWorkshopOrdersScreen',
  props: {},
  components: { OpenOrdersModal },
  validations() {
    let rules = {
      amount: {
        required,
        minValue: minValue(1.0),
        decimal,
      },
    };
    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });
    return {
      form: rules,
    };
  },
  data() {
    return {
      lastTypePreviewed: null,
      pdfUrl: null,
      form: {
        amount: '',
      },
      invoiceGenerationModal: {
        show: false,
        orderId: 0,
        invoices: [],
        customerId: '',
        quoteId: '',
      },
      table: {
        url: uris.workshopNoStockOrdersURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'customer_full_name',
          'abbr_product_names',
          // 'created_by',
          'total_price',
          'in_delivery',
          'destination',
          'status',
          'origin',
          'invoice',
          'actions',
        ],
        options: {
          rowClassCallback: function (row) {
            return row.status === 'Received' ? 'bg-light-warning' : '';
          },
          saveState: true,
          sortable: ['modified_at', 'created_at'],
          headings: {
            invoice: 'Facturas',
            origin: 'Origen',
            destination: 'Destino',
            in_delivery: 'Albarán',
            status: 'Estado',
            customer_full_name: 'Cliente',
            abbr_product_names: 'Productos',
            modified_at: 'Modificado',
            created_at: 'Creado',
            total_price: 'Total',
            id: '# Pedido',
            created_by: 'Creado por',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  filters: {
    formatStatus: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
    formatDateTime: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(val) {
      return val.toFixed(2);
    },
  },
  computed: {
    quotesLink() {
      return this.$router.resolve({
        name: 'AdminQuotesEditScreen',
        params: { id: this.invoiceGenerationModal.quoteId },
      }).href;
    },
    customersLink() {
      return this.$router.resolve({
        name: 'AdminCustomersEditScreen',
        params: { id: this.invoiceGenerationModal.customerId },
      }).href;
    },
    pdfUrlFinal() {
      return `${this.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`;
    },
  },
  methods: {
    confirmGenerateInvoice() {
      if (this.lastTypePreviewed == 'partial') {
        this.generatePartialInvoice();
      } else {
        this.generateTotalInvoice();
      }
    },
    resetModal() {
      this.invoiceGenerationModal.orderId = null;
      this.invoiceGenerationModal.invoices = null;
      this.invoiceGenerationModal.hasTotalInvoice = null;
      this.invoiceGenerationModal.customerId = '';
      this.invoiceGenerationModal.quoteId = '';
      this.form.amount = '';
      this.$v.$reset();
    },
    downloadInvoice(invoiceId) {
      actions.downloadInvoice(invoiceId).then((x) => {
        let fileName = 'test.pdf';
        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }
        let blob = new Blob([x.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
    },
    previewPartialInvoice() {
      this.lastTypePreviewed = 'partial';
      let data = {
        amount: this.form.amount,
      };

      actions
        .postWorkshopOrderPreviewInvoicePartial(
          this.invoiceGenerationModal.orderId,
          data
        )
        .then((y) => {
          let fileName = 'test.pdf';
          const contentDisposition = y.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }
          let blob = new Blob([y.data], { type: 'application/pdf' });
          this.pdfUrl = URL.createObjectURL(blob);
          // let link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = fileName;
          // link.click();
        });
    },
    generatePartialInvoice() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let data = {
        amount: this.form.amount,
      };
      actions
        .postWorkshopOrderGenerateInvoicePartial(
          this.invoiceGenerationModal.orderId,
          data
        )
        .then((y) => {
          this.refreshTable();
          const invoiceId = y.data.id;
          this.downloadInvoice(invoiceId);
          this.invoiceGenerationModal.show = false;
        });
    },
    previewTotalInvoice() {
      this.lastTypePreviewed = 'total';
      actions
        .postWorkshopOrderPreviewInvoiceTotal(
          this.invoiceGenerationModal.orderId
        )
        .then((y) => {
          let fileName = 'test.pdf';
          const contentDisposition = y.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }
          let blob = new Blob([y.data], { type: 'application/pdf' });
          this.pdfUrl = URL.createObjectURL(blob);
          // let link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = fileName;
          // link.click();
        });
    },
    generateTotalInvoice() {
      actions
        .postWorkshopOrderGenerateInvoiceTotal(
          this.invoiceGenerationModal.orderId
        )
        .then((y) => {
          this.refreshTable();
          const invoiceId = y.data.id;
          this.downloadInvoice(invoiceId);
          this.invoiceGenerationModal.show = false;
        });
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    downloadOrder(id) {
      actions.downloadOrder(id).then((x) => {
        let fileName = 'Pedido.pdf';

        const contentDisposition = x.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1];
          }
        }

        let blob = new Blob([x.data], { type: 'application/pdf' });

        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    downloadWorkshopOrderLegal(id, invoiceID) {
      if (
        invoiceID ||
        (!invoiceID &&
          confirm(
            '¿Estás seguro que deseas generar una factura para el pedido ' +
              id +
              '?'
          ))
      ) {
        actions.downloadWorkshopOrderLegal(id).then((x) => {
          let fileName = 'Factura.pdf';

          const contentDisposition = x.headers['content-disposition'];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+)/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          let blob = new Blob([x.data], { type: 'application/pdf' });

          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();

          //this.$refs.table.refresh();
        });
      }
      // uris.quoteDownloadURI(id);
    },
    downloadOrderLegalBtn(orderId, invoices, customerId, quoteId) {
      this.invoiceGenerationModal.orderId = orderId;
      this.invoiceGenerationModal.invoices = invoices;

      this.invoiceGenerationModal.customerId = customerId.toString();
      this.invoiceGenerationModal.quoteId = quoteId.toString();

      this.invoiceGenerationModal.hasTotalInvoice = invoices.some(
        (x) => x.is_partial === false
      );

      this.invoiceGenerationModal.show = true;
      // if (
      //   invoices ||
      //   (!invoices &&
      //     confirm(
      //       '¿Estás seguro que deseas generar una factura para el pedido ' +
      //         orderId +
      //         '?'
      //     ))
      // ) {
      //   actions.downloadOrderLegal(orderId).then((x) => {
      //     let fileName = 'Factura.pdf';

      //     const contentDisposition = x.headers['content-disposition'];
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename=(.+)/);
      //       if (fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1];
      //       }
      //     }

      //     let blob = new Blob([x.data], { type: 'application/pdf' });

      //     let link = document.createElement('a');
      //     link.href = window.URL.createObjectURL(blob);
      //     link.download = fileName;
      //     link.click();

      //   });
      // }
    },
    downloadOrderWorkshop(id) {
      actions.downloadWorkshopOrderWorkshop(id).then((x) => {
        let fileName = 'Orden-taller.html';

        console.log();

        var winPrint = window.open(
          '',
          '',
          'left=0,top=0,width="100%",height="100%",toolbar=1,scrollbars=1,status=0'
        );
        winPrint['BASE_URL'] = process.env.VUE_APP_API_BASE_URL.replace(
          'api/',
          ''
        );
        winPrint.document.write(x.data);
        winPrint.document.close();
        // winPrint.print();
        winPrint.focus();
        // winPrint.print();
        // winPrint.close();
        // const contentDisposition = x.headers['content-disposition'];
        // if (contentDisposition) {
        //   const fileNameMatch = contentDisposition.match(/filename=(.+)/);
        //   if (fileNameMatch.length === 2) {
        //     fileName = fileNameMatch[1];
        //   }
        // }

        // let blob = new Blob([x.data], { type: 'text/html' });

        // let link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // link.download = fileName;
        // link.click();
      });
      // uris.quoteDownloadURI(id);
    },
    // removeSelected() {
    //   this.table.selected.map((x) => {
    //     this.removeOrder(x);
    //   });
    // },
    removeOrder(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el pedido número ' + id + '?'
        )
      ) {
        actions.deleteWorkshopOrder(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.pdfPreview {
  overflow: hidden;
  height: 100%;
  width: 100%;
  min-height: 400px;
}
::v-deep .bg-light-warning {
  background-color: rgba(255, 255, 213, 0.55) !important;
  &:hover {
    color: #212529;
    background-color: rgba(255, 255, 213, 0.95) !important;
  }
}
</style>
